import DataTableContainer from '../../dashboards/data-table-container';
import { AgendasDataTable } from './components/agendas-data-table';

export const AgendasSection = () => {
  return (
    <DataTableContainer>
      <h1>Agendas</h1>
      <AgendasDataTable />
    </DataTableContainer>
  );
};
